export default "__VITE_ASSET__3dba789e__"